import ReactDOM from 'react-dom/client';
import ReactModal from 'react-modal';

import './i18n/config';
import { Router } from './Router';

import './index.scss';

// Tell react-modal which element to apply aria-hidden to when modals open.
ReactModal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<Router />);
